import React, { useState, useEffect, useRef } from 'react';
import { ColorRing } from "react-loader-spinner";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';

import './Result.css';
import ReportTemplate from './Util/ReportTemplate';
import { expense } from './Util/Expense';
// import EmailModal from './Util/EmailModal';

export default function Result(props) {

  // const [showEmailModal, setShowEmailModal] = useState(false)
  const [estimate, setEstimate] = useState({})
  const [_loaded, set_Loaded] = useState(false)
  const [fresh, setFresh] = useState(false)
  const reportTemplateRef = useRef(null)

  useEffect(() => {
    //Component mounted
    const controller = new AbortController()
    const signal = controller.signal
    expense(signal, props.data).then(ans => { setEstimate(ans); set_Loaded(true); })


    return () => {
      //Component unmounted
      controller.abort()
    }
    //eslint-disable-next-line
  }, [fresh]) // Empty dependency array to run the effect. 

  //FIFTH TRY
  const makePdf = () => {

    html2canvas(reportTemplateRef.current)
      .then((canvas) => {
        const componentWidth = reportTemplateRef.current.offsetWidth
        const componentHeight = reportTemplateRef.current.offsetHeight
        const orientation = componentWidth >= componentHeight ? 'l' : 'p'

        const imgData = canvas.toDataURL('image/png')
        const doc = new jsPDF({ orientation, unit: 'px' })

        doc.internal.pageSize.width = componentWidth
        doc.internal.pageSize.height = componentHeight

        doc.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight)
        doc.save('Estimated Expenses.pdf')
      })
  }
  // const sendEmail = (to) => {
  //   //TODO more on the email
  //   return
  // }

  const refresh = async () => {
    await set_Loaded(false)
    setFresh(!fresh)
  }

  return (
    <>
      {
        _loaded
          ?
          <>
            <div className="pdf-option" style={{ textAlign: 'center', padding: 20 }}>
              {/* <button className="hoverable" onClick={() => setShowEmailModal(true)}>Email PDF</button> */}
              <button className="hoverable" onClick={makePdf}>Make PDF</button>
            </div>
            <hr />

            <div ref={reportTemplateRef}>
              <ReportTemplate
                data={props.data}
                invalid={props.invalid}
                changeState={props.changeState}
                estimate={estimate}
                refresh={refresh} />
            </div>

            <div style={{ textAlign: 'center', padding: 20 }}>
              <button className="hoverable" onClick={props.onPrev}>PREVIOUS</button>
              <button className="hoverable" onClick={props.onRestart}>START OVER</button>
            </div>

            {/* <EmailModal showEmailModal={showEmailModal} sendEmail={sendEmail} setShowEmailModal={setShowEmailModal}/> */}
          </>
          :
          <div style={{ height: '100%', width: '100%', textAlign: 'center' }}>
            <ColorRing color="#8884D8" height={800} />
          </div>
      }
    </>
  )
}
